<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Examination Registration URL for {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column align-items-center">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Registration URL</label>
        <textarea class="form-control" disabled [(ngModel)]="examUrl" name="examUrl"></textarea>
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Self Registration End Date</label>
        <input class="form-control" type="text" disabled [(ngModel)]="selfDate" name="selfDate">
      </div>

    </form>
  </div>
</div>